import React from 'react';
import { palette } from '../../style-utils/theme';

interface EyeProps {
  color?: string;
  /**
   * TRUE draws the strike-through — "password is hidden, press to reveal".
   *
   * The icon used to be slashed unconditionally and had no callers at all,
   * while three password fields reached for Font Awesome's `fa-eye` /
   * `fa-eye-slash` instead. That pulled a render-blocking 6.4.0 stylesheet from
   * cdnjs into the critical path of the LOGIN screen — an entire icon font, off
   * a third-party origin, for two glyphs.
   */
  slashed?: boolean;
}

/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const Eye: React.FC<EyeProps> = ({
  color = palette.slate,
  slashed = false,
}) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9202 12.7988C15.9725 12.5407 16 12.2736 16 12C16 9.79086 14.2091 8 12 8C11.7264 8 11.4593 8.02746 11.2012 8.07977L12.1239 9.00251C13.6822 9.06583 14.9342 10.3178 14.9975 11.8761L15.9202 12.7988ZM9.39311 10.5143C9.14295 10.9523 9 11.4595 9 12C9 13.6569 10.3431 15 12 15C12.5405 15 13.0477 14.857 13.4857 14.6069L14.212 15.3332C13.5784 15.7545 12.8179 16 12 16C9.79086 16 8 14.2091 8 12C8 11.1821 8.24547 10.4216 8.66676 9.78799L9.39311 10.5143Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1537 17.2751L15.4193 16.5406C14.3553 17.1196 13.1987 17.5 12 17.5C10.3282 17.5 8.73815 16.7599 7.36713 15.7735C6.00005 14.79 4.89305 13.5918 4.19791 12.7478C3.77355 12.2326 3.72972 12.1435 3.72972 12C3.72972 11.8565 3.77355 11.7674 4.19791 11.2522C4.8672 10.4396 5.91829 9.29863 7.21571 8.33704L6.50138 7.62271C5.1699 8.63072 4.10382 9.79349 3.42603 10.6164L3.36722 10.6876C3.03669 11.087 2.72972 11.4579 2.72972 12C2.72972 12.5421 3.03669 12.913 3.36722 13.3124L3.42602 13.3836C4.15098 14.2638 5.32013 15.5327 6.78311 16.5853C8.24215 17.635 10.0361 18.5 12 18.5C13.51 18.5 14.9196 17.9886 16.1537 17.2751ZM9.18992 6.06861C10.0698 5.71828 11.0134 5.5 12 5.5C13.9639 5.5 15.7579 6.365 17.2169 7.41472C18.6799 8.46727 19.849 9.73623 20.574 10.6164L20.6328 10.6876C20.9633 11.087 21.2703 11.4579 21.2703 12C21.2703 12.5421 20.9633 12.913 20.6328 13.3124L20.574 13.3836C20.0935 13.9669 19.4179 14.721 18.591 15.4697L17.883 14.7617C18.6787 14.0456 19.3338 13.3164 19.8021 12.7478C20.2264 12.2326 20.2703 12.1435 20.2703 12C20.2703 11.8565 20.2264 11.7674 19.8021 11.2522C19.107 10.4082 17.9999 9.21001 16.6329 8.22646C15.2618 7.24007 13.6718 6.5 12 6.5C11.3056 6.5 10.6253 6.62768 9.96896 6.84765L9.18992 6.06861Z"
        fill={color}
      />
      {slashed ? (
        <path d="M5 2L21 18" stroke={color} strokeLinecap="round" />
      ) : null}
    </svg>
  );
};
